export default "__VITE_ASSET__CjQozMFV__"